import { useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../Components/Layout/Layout";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Decryptedid, Encryptedid } from "../Util/BcruptEncyptid";
import moment from "moment";
import ConfirmModal from "../modals/ConfirmModal";
import LoaderComponent from "../Components/common/LoaderComponent";
import UserInfo from "../Hooks/UserInfo";
import WeeklyLoginChart from "../Components/common/WeeklyLoginChart";
import { convertTime } from "../Util/HelperFunction";
import { parentdetailsAction } from "../Redux/Action/parentAction";
import AddParentModal from "../modals/AddParentModal";
import WeekPicker from "../Components/common/WeekPicker";
import { resolveReturnUrl } from "../Util/HelperFunction";
export default function ParentProfile() {
  const { userInfo, parentDetailPermission } = UserInfo();

  const navigate = useNavigate();
  const location = useLocation();
  const returnUrl = resolveReturnUrl({
    search: location.search,
    fallbackRoute: "Parents",
  });
  const [parentdetails, setParentdetails] = useState({});
  const [loading, setLoading] = useState(true); // State for loading
  const dispatch = useDispatch();

  const { id } = useParams();
  const idval = Decryptedid(atob(id));

  const [WeekCount, setWeekCount] = useState(0);
  const [selectedWeek, setSelecteWeek] = useState("");
  const [selectedType, setSelectedType] = useState(" ");
  const [isModalOpen, setModalOpen] = useState(false);
  const [ParentModal, setParentModal] = useState(false);

  const handleParentModalClose = () => {
    setParentModal(false);
  };

  const handleParentModalOpen = () => {
    setParentModal(true);
  };

  const [selecteDates, setSelecteDates] = useState({
    startOfWeek: "",
    endOfWeek: "",
  });

  useEffect(() => {
    setLoading(true);
    dispatch(parentdetailsAction({ id: idval })).then(function (data) {
      setParentdetails(data.payload.data);
      setLoading(false);
    });
  }, [idval, ParentModal, isModalOpen]);

  const handleResPassword = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };


  const goToStudentCollection = (ele) => {
    if (ele.createdBy === "Teacher") {
      navigate(`/student-collection/${Encryptedid(ele._id)}`, {
        state: ele.teacherId.firstName,
      });
    } else if (ele.createdBy === "School") {
      navigate(`/student-collection/${Encryptedid(ele._id)}`, {
        state: ele.schoolId.schoolName,
      });
    } else if (ele.createdBy === "Student") {
      navigate(`/student-collection/${Encryptedid(ele._id)}`, {
        state: ele.studentId.firstName,
      });
    } else {
      navigate(`/student-collection/${Encryptedid(ele._id)}`, {
        state: "Student",
      });
    }
  };


  const handleSuspend = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  const handleDelete = (type) => {
    setModalOpen(true);
    setSelectedType(type);
  };

  return (
    <Layout>
      {loading && <LoaderComponent />}
      <div className="right-top">
        <div className="heading-top">
          <p>All Parents / @{parentdetails?.firstName || "Parent"} </p>
          <div className="back-page-title">
            <Link
              to=""
              onClick={(e) => {
                e.preventDefault();
                navigate(returnUrl);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
              >
                <path
                  d="M13.75 5.5L8.25 11L13.75 16.5"
                  stroke="#CCD2E3"
                  strokeWidth="2"
                />
              </svg>
            </Link>
            <h2>
              @{parentdetails?.firstName || "Parent"}
              <span> {parentdetails?.sr_no || ""}</span>
            </h2>
          </div>
        </div>
        <div className="user-side-pro">
          <Link to="">
            
            <img
              src={
                userInfo?.image
                  ? userInfo?.image
                  : require("../Assets/Images/user.png")
              }
              alt="User"
              style={{
                borderRadius: "50%",
                height: 50,
                width: 50,
                objectFit: "cover",
              }}
            />
          </Link>
        </div>
      </div>
      <Container fluid>
        <Row className="pb-5">
          <Col lg={12}>
            <Row>
              <Col lg={4} className="mb-4 display-table">
                <div className="school-profile-detail">
                  <div className="card-edit d-flex justify-content-end">
                    <button
                      style={{ border: "0", background: "unset", padding: "0" }}
                      disabled={!parentDetailPermission}
                      className="text-end pe-3 pt-3 mb-4"
                      onClick={handleParentModalOpen}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_51_2041)">
                          <path
                            d="M2.25 13.095V15.375C2.25 15.585 2.415 15.75 2.625 15.75H4.905C5.0025 15.75 5.1 15.7125 5.1675 15.6375L13.3575 7.455L10.545 4.6425L2.3625 12.825C2.2875 12.9 2.25 12.99 2.25 13.095ZM15.5325 5.28C15.825 4.9875 15.825 4.515 15.5325 4.2225L13.7775 2.4675C13.485 2.175 13.0125 2.175 12.72 2.4675L11.3475 3.84L14.16 6.6525L15.5325 5.28Z"
                            fill="#8F9BBA"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_51_2041">
                            <rect width="18" height="18" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </div>
                  <div className="qr-code">
                    <img
                      className="img-fluid"
                      height={100}
                      width={100}
                      src={
                        parentdetails?.image
                          ? parentdetails?.image
                          : require("../Assets/Images/student.png")
                      }
                    />
                  </div>
                  <div className="">
                    <p className="heavy-text mb-0 ">
                      @{parentdetails?.firstName || "Parent"}
                    </p>

                    {parentdetails?.firstName ? (
                      <p className="mb-0">
                        {parentdetails?.firstName} {parentdetails?.surName}
                      </p>
                    ) : (
                      <p className="mb-0">N/A</p>
                    )}
                    <p className="mb-0">
                      {parentdetails?.schoolId?.schoolName}
                    </p>

                    <p>Key Stage {parentdetails?.group}</p>
                  </div>
                  <div className="three-detail">
                    <div className="info-about-school">
                      <p className="heavy-text mb-0 ">
                        {moment(parentdetails?.createdAt).format("MMM YYYY")}
                      </p>
                      <p>Created</p>
                    </div>
                    <div className="info-about-school">
                      <p className="heavy-text mb-0 ">
                        {moment(parentdetails?.lastLoggedIn).format("MMM YYYY")}
                      </p>
                      <p>Last Active</p>
                    </div>
                  </div>
                  <div className="mt-4">
                    <p className="mb-2">Contact</p>
                    <p className="heavy-text mb-0 ">
                      E: {parentdetails?.email || "N/A"}
                    </p>
                  </div>
                  <div className="action-school-btns">
                    {parentdetails?.isBlocked ? (
                      <button
                        className="reset-pass"
                        onClick={() => handleSuspend("parentActiveAccount")}
                        disabled={!parentDetailPermission}
                      >
                        Active Account
                      </button>
                    ) : (
                      <button
                        className="reset-pass"
                        onClick={() => handleSuspend("parentSuspend")}
                        disabled={!parentDetailPermission}
                      >
                        Suspend Account
                      </button>
                    )}

                    <button
                      className="reset-pass"
                      onClick={() => handleResPassword("parentResetPassword")}
                      disabled={!parentDetailPermission}
                    >
                      Reset Password
                    </button>

                    <button
                      className="reset-pass"
                      onClick={() => handleDelete("parentDelete")}
                      disabled={!parentDetailPermission}
                    >
                      Delete Account
                    </button>
                  </div>
                </div>
              </Col>

              <Col lg={8} className="mb-4 display-table">
                <Row>
                  <Col lg={12}>
                    <div className="teacher-search-history mt-0 position-relative">
                      <h2>Collections</h2>

                      <div className="collections-list-pro">
                        <>
                          {Array.isArray(parentdetails?.collectionId) &&
                          parentdetails?.collectionId.length > 0 ? (
                            <>
                              {parentdetails?.collectionId.map((ele, index) => (
                                <Col lg={12} className="mt-2" key={index}>
                                  <div
                                    className="collection-video-inner"
                                    onClick={() => goToStudentCollection(ele)}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <Row>
                                      <Col lg={3} md={3} sm={3} xs={4}>
                                        <img
                                          key={ele?._id}
                                          src={
                                            ele?.image
                                              ? ele?.image
                                              : require("../Assets/Images/clogo.png")
                                          }
                                          alt={ele?.name}
                                          onError={(e) => {
                                            e.target.src = require("../Assets/Images/clogo.png");
                                          }}
                                        />
                                      </Col>
                                      <Col
                                        lg={6}
                                        md={7}
                                        sm={7}
                                        xs={6}
                                        className=""
                                      >
                                        <div className="count-section">
                                          <h3>{ele.name}</h3>
                                          <p
                                            style={{
                                              fontSize: "14px",
                                              color: "#2B3674",
                                              margin: "0 0 5px 0",
                                              lineHeight: "6px",
                                            }}
                                          >
                                            Created by:{" "}
                                            <>
                                              {ele?.createdBy === "Teacher" && (
                                                <>
                                                  {ele?.teacherId?.firstName}{" "}
                                                  {ele?.teacherId?.surName}
                                                </>
                                              )}

                                              {ele?.createdBy === "School" && (
                                                <>{ele?.schoolId?.schoolName}</>
                                              )}

                                              {ele?.createdBy ===
                                                "SchoolAdmin" && (
                                                <>
                                                  {
                                                    ele?.schoolAdminId
                                                      ?.firstName
                                                  }{" "}
                                                  {ele?.schoolAdminId?.surName}
                                                </>
                                              )}
                                              {ele?.createdBy === "Student" && (
                                                <>
                                                  {ele?.studentId?.name}
                                                  {
                                                    ele?.studentId?.firstName
                                                  }{" "}
                                                  {ele?.studentId?.surName}
                                                </>
                                              )}
                                            </>
                                          </p>
                                          <div className="count-desc pt-1  ">
                                            <p>
                                              Shared with{" "}
                                              {ele?.sharedWithStudentsCount ??
                                                0}{" "}
                                              student
                                              {ele?.sharedWithStudentsCount ===
                                              1
                                                ? ""
                                                : "s"}
                                            </p>

                                            <p>
                                              Shared with{" "}
                                              {ele?.sharedWithTeachersOrAdminsCount ??
                                                0}{" "}
                                              teacher
                                              {ele?.sharedWithTeachersOrAdminsCount ===
                                              1
                                                ? ""
                                                : "s"}
                                            </p>
                                          </div>
                                        </div>
                                        <p>
                                          Created on{" "}
                                          {ele?.createdAt
                                            ? moment(ele?.createdAt).format(
                                                "DD/MM/YYYY",
                                              )
                                            : null}
                                        </p>
                                      </Col>
                                      <Col
                                        lg={3}
                                        md={2}
                                        sm={2}
                                        xs={2}
                                        className="video-count-sec"
                                      >
                                        <div className="videos-count">
                                          <p className="text-end">
                                            {Array.isArray(ele?.video) &&
                                            ele?.video.length > 0
                                              ? ele?.video?.length
                                              : 0}{" "}
                                            videos
                                          </p>
                                        </div>
                                        <div className="security-sec bottom-0 d-flex gap-2 ">
                                          {ele?.accessType == "PUBLIC" && (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="11"
                                                height="14"
                                                viewBox="0 0 11 14"
                                                fill="none"
                                              >
                                                <rect
                                                  x="1"
                                                  y="5.6152"
                                                  width="9.23077"
                                                  height="7.38474"
                                                  rx="1"
                                                  stroke="#201A46"
                                                  strokeWidth="0.8"
                                                  stroke-linejoin="round"
                                                />
                                                <rect
                                                  x="4.75"
                                                  y="8.50015"
                                                  width="1.49944"
                                                  height="1.49946"
                                                  rx="0.74972"
                                                  stroke="#201A46"
                                                  strokeWidth="0.8"
                                                  stroke-linejoin="round"
                                                />
                                                <path
                                                  d="M7.92398 2.97805V2.97805C7.92398 1.88561 7.03838 1 5.94593 1H5.61629C4.34178 1 3.30859 2.03319 3.30859 3.30769V5.61546H5.61629"
                                                  stroke="#201A46"
                                                  strokeWidth="0.8"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                              <p>Public</p>
                                            </>
                                          )}
                                          {ele?.accessType ==
                                            "PRIVATE_GROUP" && (
                                            <>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                              >
                                                <circle
                                                  cx="9.5"
                                                  cy="12.5"
                                                  r="2.5"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M14 19.75C14 21.8211 11.5711 22 9.5 22C7.42893 22 5 21.8211 5 19.75C5 17.6789 7.42893 16 9.5 16C11.5711 16 14 17.6789 14 19.75Z"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M13.5527 14.7711C14.6631 14.7711 15.5633 13.8709 15.5633 12.7605C15.5633 11.6501 14.6631 10.75 13.5527 10.75"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M16.5685 18.9999C16.5685 17.2252 15.2379 15.6654 13.5527 14.771"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M5.01562 14.7711C3.90524 14.7711 3.00509 13.8709 3.00509 12.7605C3.00509 11.6501 3.90524 10.75 5.01562 10.75"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <path
                                                  d="M1.99982 18.9999C1.99982 17.2252 3.33042 15.6654 5.01562 14.771"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linecap="round"
                                                />
                                                <rect
                                                  x="15"
                                                  y="4.15356"
                                                  width="6.30769"
                                                  height="5.04615"
                                                  rx="1"
                                                  stroke="#99A1BB"
                                                  stroke-linejoin="round"
                                                />
                                                <rect
                                                  x="17.5625"
                                                  y="6.125"
                                                  width="1.025"
                                                  height="1.025"
                                                  rx="0.5125"
                                                  stroke="#99A1BB"
                                                  stroke-linejoin="round"
                                                />
                                                <path
                                                  d="M16.5781 2.57692C16.5781 1.70601 17.2841 1 18.155 1V1C19.026 1 19.732 1.70601 19.732 2.57692V4.15385H18.155H16.5781V2.57692Z"
                                                  stroke="#99A1BB"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                              <p>Share Only</p>
                                            </>
                                          )}
                                          {ele?.accessType == "PRIVATE" && (
                                            <>
                                              <svg
                                                className="private"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="16"
                                                height="20"
                                                viewBox="0 0 16 20"
                                                fill="none"
                                              >
                                                <rect
                                                  x="1"
                                                  y="8"
                                                  width="14"
                                                  height="11.2"
                                                  rx="1"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linejoin="round"
                                                />
                                                <rect
                                                  x="6.6875"
                                                  y="12.375"
                                                  width="2.275"
                                                  height="2.275"
                                                  rx="1.1375"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linejoin="round"
                                                />
                                                <path
                                                  d="M4.5 4.5C4.5 2.567 6.067 1 8 1V1C9.933 1 11.5 2.567 11.5 4.5V8H8H4.5V4.5Z"
                                                  stroke="#99A1BB"
                                                  strokeWidth="1.5"
                                                  stroke-linejoin="round"
                                                />
                                              </svg>
                                              <p>Private</p>
                                            </>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                </Col>
                              ))}
                            </>
                          ) : (
                            <p className="data-not-found-cmn">Data Not Found</p>
                          )}
                        </>
                      </div>
                    </div>
                  </Col>
                </Row>

                <Col lg={12}>
                  {" "}
                  <div className="teacher-search-history ">
                    <h2>Search History</h2>
                    <div className="search-history-list-pro position-relative">
                      {parentdetails &&
                      Array.isArray(parentdetails?.searched) &&
                      parentdetails?.searched?.length > 0 ? (
                        parentdetails?.searched.map((res, index) => {
                          return (
                            <>
                              <div className="search-history-list" key={index}>
                                <h4>{res.searched}</h4>
                                <p>
                                  {moment(res?.createdAt).format("DD/MM/YYYY")}
                                </p>
                              </div>
                            </>
                          );
                        })
                      ) : (
                        <p className="data-not-found-cmn">Data Not Found</p>
                      )}
                    </div>
                  </div>
                </Col>
                <Row></Row>
              </Col>
            </Row>
          </Col>
          <Col lg={12}>
            <Row>
              <Col lg={4} className="display-table">
                <div className="teacher-search-history table-cell">
                  <div className=" position-relative">
                    <div className="">
                      <div className="details-chart">
                        <div>
                          <p>Daily Usage</p>
                          <h5>
                            {convertTime(Math.trunc(WeekCount))}{" "}
                            <span>Average</span>
                          </h5>
                        </div>
                        <WeekPicker
                          setSelectedDates={setSelecteDates}
                          type="TopCategories"
                        />
                      </div>
                      <WeeklyLoginChart
                        setWeekCount={setWeekCount}
                        selecteDates={selecteDates}
                        selectedWeek={selectedWeek}
                        type="parent"
                        idval={idval}
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={8} className="display-table">
                <div className="teacher-search-history table-cell">
                  <h2>Recent Viewing History</h2>
                  <div className="viewing-history-list-scrol position-relative">
                    {Array.isArray(parentdetails?.history) &&
                    parentdetails?.history.length > 0 ? (
                      parentdetails?.history?.map((res, index) => {
                        return (
                          <>
                            <div className="search-history-list" key={index}>
                              <Link
                                to={
                                  "/single-video/" + Encryptedid(res?.video?._id)
                                }
                              >
                                <div className="viewing-h-pro">
                                  <img
                                    src={
                                      res?.video?.cover_url
                                        ? res.video.cover_url
                                        : null
                                    }
                                  />
                                  <div className="">
                                    <h5>{res?.video?.title}</h5>
                                    <p className="mb-0">
                                      {" "}
                                      {res?.video?.categoryId?.title}
                                    </p>
                                  </div>
                                </div>
                              </Link>
                              <p>
                                {res?.createdAt
                                  ? moment(res?.createdAt).format("DD/MM/YYYY")
                                  : null}
                              </p>
                            </div>
                          </>
                        );
                      })
                    ) : (
                      <p className="data-not-found-cmn">Data Not Found</p>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
          
        </Row>
      </Container>

      <ConfirmModal
        data={idval}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
        extraFunction={null}
      />

      <AddParentModal
        ParentModal={ParentModal}
        handleParentModalClose={handleParentModalClose}
        typeModal="editParent"
        EditData={parentdetails}
        idval={idval}
      />
    </Layout>
  );
}
